// @core/api/endpoints/audittrail/execute_retention_purge.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExecuteRetentionPurgeRequest,
  ExecuteRetentionPurgeResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Execute retention purge
 * Manually triggers a retention purge for the specified policy. Removes or archives records that have exceeded their retention period.
 */
export async function ExecuteRetentionPurge(
  policy_id: string,
  data: ExecuteRetentionPurgeRequest,
  options?: RequestOptions
): Promise<ExecuteRetentionPurgeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/retention-policies/:policy_id/purge`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.post<ExecuteRetentionPurgeResponse>(requestPath, data, requestOptions);
}
